import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  Container,
  Flex,
  Heading,
  Select,
  SimpleGrid,
  SkeletonText,
  Stack,
  useColorMode,
  useToast,
} from "@chakra-ui/react";
import BillingCycleToggle from "./InfProfileToggle";
import {
  Textarea,
  Input,
  Menu,
  MenuGroup,
  InputGroup,
  Card,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  InputRightElement,
  TagCloseButton,
  VStack,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { Spinner } from "@chakra-ui/react";
import { IoMdTrash, IoIosArrowBack } from "react-icons/io";
import { format, parseISO, set } from "date-fns";
import { useNavigate } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import "../Table/links.css";
import axios from "axios";
import {
  FaFileContract,
  FaYoutube,
  FaInstagram,
  FaTiktok,
  FaFacebook,
  FaSnapchat,
  FaGlobe,
} from "react-icons/fa";
import { Tag, Wrap, TagLabel } from "@chakra-ui/react";
import { FaFileCircleXmark } from "react-icons/fa6";
import { FaUpload } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Image } from "@chakra-ui/react";
import { FormControl, FormLabel, Link } from "@chakra-ui/react";
import { IoImages } from "react-icons/io5";
import { useRef } from "react";
import { IoLogoYoutube } from "react-icons/io5";
import { IoLogoInstagram } from "react-icons/io5";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from "@chakra-ui/react";
import { IoLogoTiktok } from "react-icons/io5";
import { BiCaretDown } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { setUserImg } from "../../store/store";
import { useGoogleLogin } from "@react-oauth/google";
import PremiumFeatureModal from "../Modal/PremiumFeatureModal";
import MembershipDowngradeModel from "../Modal/MembershipDowngradeModel";
import { values } from "lodash";
import { ClimbingBoxLoader } from "react-spinners";

const membershipFeatures = {
  free: ["Deals Feature"],
  Marketing: ["Deals Feature", "Outreach Feature", "Auto Follow-Ups"],
  Administrative: ["Deals Feature", "Contract Feature", "Invoice Feature"],
  Complete: [
    "Deals Feature",
    "Contract Feature",
    "Invoice Feature",
    "Outreach Feature",
    "Auto Follow-Ups",
    "Added to CM Pitch Deck",
  ],
};

const TABS = [
  "personal",
  "youtube",
  "instagram",
  "tiktok",
  "usage",
  "meta-tags",
  "payment-info",
  "connect",
  "import-data",
  "membership",
];

const ProfileTable = () => {
  const BASE_URL = process.env.REACT_APP_DEPLOYED_BASE_URL;
  const token = localStorage.getItem("token");
  const role =
    useSelector((state) => state.role) || localStorage.getItem("Role");
  const imageInputRef = useRef(null);
  const [isFileLoading, setIsFileLoading] = useState(false);
  // const [isOpenNotificationModal, setIsOpenNotificationModal] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams();
  const [isInProgress, setIsInProgress] = useState(false);
  const [messageInprogress, setMessageInprogress] = useState(null);
  const tabNameParam = searchParams.get("tab");
  const toast = useToast();
  const { colorMode } = useColorMode();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [ID, setID] = useState("");
  const [TalName, setTalName] = useState("");
  const [InfluencersId, setInfluencersId] = useState("");
  const [showBlockedModal, setShowBlockedModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [updateApi, setUpdateApi] = useState(false);
  const [viewData, setViewData] = useState("");
  const [viewData1, setViewData1] = useState("");
  const [deleteInvoiceId, setDeleteInvoiceId] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [roles, setRoles] = useState(role);
  const [mainPath, setMainPath] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [isOpenClockConfirmationModel, setIsOpenClockConfirmationModel] =
    useState(false);
  const [profilePictureUrl, setProfilePictureUrl] = useState("");
  const [profileData, setProfileData] = useState("");
  const [paymentInfo, setPaymentInfo] = useState("");
  const [planInfo, setPlanInfo] = useState("");
  const [editedInvoice, setEditedInvoice] = useState("");
  const [activeMetaTagDropdown, setActiveMetaTagDropdown] = useState(false);
  const [featureMessage, setFeatureMessage] = useState("");
  const [selectedMetaTags, setSelectedMetaTags] = useState([]);
  const [isFeatureAccess, setIsFeatureAccess] = useState(false);
  const [metaTags, setMetaTags] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isPremium, setIsPremium] = useState(false);
  const [filteredMetaTagData, setFilteredMetaTagData] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [inputCompanyValue, setInputCompanyValue] = useState("");
  const [connectedMail, setConnectedMail] = useState("");
  const [company, setCompany] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [companySearch, setCompnaySearch] = useState(false);
  const [isConnected, setIsConnected] = useState(null);
  const [currentMembership, setCurrentMembership] = useState(null);
  const [billingCycle, setBillingCycle] = useState("Monthly");
  const [isScanning, setIsScanning] = useState(false);
  const [labels, setLabels] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isLoadingTotal, setIsLoadingTotal] = useState(false);
  const [totalEmails, setTotalEmails] = useState(null);

  const [inputValue, setInputValue] = useState({
    // profile_picture: "",
    first_name: "",
    last_name: "",
    phone: "",
    birthday: "",
    address: "",
    youTube_username: "",
    dedicated_youTube_rate: "",
    partial_youTube_rate: "",
    youTube_shorts_rate: "",
    IG_reel_rate: "",
    IG_Story_rate: "",
    IG_Feed_rate: "",
    tikTok_rate: "",
    usage_rate: "",
    instagram_username: "",
    tikTok_username: "",
    meta_tags: [],
    categories: [],
    country: "",
    yt_subscriber_count: "",
    yt_us_percentage: "",
    yt_female_percentage: "",
    yt_male_percentage: "",
    ig_followers_count: "",
    ig_us_percentage: "",
    ig_female_percentage: "",
    ig_male_percentage: "",
    tk_followers_count: "",
    tk_us_percentage: "",
    tk_female_percentage: "",
    tk_male_percentage: "",
  });
  const [paymentInputValue, setPaymentInputValue] = useState({
    payees_name: "",
    bank_name: "",
    account_number: "",
    routing_number: "",
    wires_domestic: "",
    swift_code: "",
    paypal_email: "",
    zelle_email: "",
  });

  const [date, setDate] = useState({
    rough_draft_date: null,
    live_date: null,
    invoice_date: null,
    payout_date: null,
    date_received: null,
  });

  const [tags, setTags] = useState([]);
  const scopes = [
    "https://www.googleapis.com/auth/gmail.send",
    "https://www.googleapis.com/auth/gmail.modify",
    "https://www.googleapis.com/auth/gmail.compose",
    "https://www.googleapis.com/auth/gmail.readonly",
    "https://www.googleapis.com/auth/pubsub",
  ];
  const [countries, setCountries] = useState([]);

  const checkFeatureAccess = async () => {
    try {
      const response = await fetch(BASE_URL + "/contract-access/", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (response.status === 200) {
        setIsFeatureAccess(true);
      } else {
        setIsFeatureAccess(false);

        setFeatureMessage(data?.error);
      }
    } catch (error) {
      console.error("Error checking feature access:", error);
      setIsFeatureAccess(false);
      setFeatureMessage("An unexpected error occurred. Please try again.");
    }
  };

  const handleTabSelect = (index) => {
    if ((index === 6 || index === 8) && !isFeatureAccess) {
      setShowBlockedModal(true);
    } else {
      setActiveTabIndex(index);
      setSearchParams({ tab: TABS[index] });
    }
  };

  useEffect(() => {
    if (!tabNameParam) {
      setSearchParams({ tab: TABS[0] }); // default to 'overview'
    }
  }, [tabNameParam, setSearchParams]);

  useEffect(() => {
    const index = TABS.indexOf(tabNameParam);
    if (index !== -1) {
      setActiveTabIndex(index);
    }
  }, [tabNameParam]);

  useEffect(() => {
    if (profileData) {
      // Extract invoice numbers from viewData1
      const invoiceNumbers = Array.isArray(viewData1)
        ? viewData1.map((invoice) => invoice.invoice_number).filter(Boolean) // Ensure valid invoice numbers
        : [];

      setInputCompanyValue(viewData?.brand_agency);
      setCompany(viewData?.brand_agency);

      setInputValue({
        first_name: profileData.first_name,
        // profile_picture :profilePictureUrl,
        last_name: profileData.last_name,
        meta_tags: profileData.meta_tags,
        categories: profileData.categories,
        country: profileData.country,
        phone: profileData.phone,
        birthday: profileData.birthday,
        address: profileData.address,
        instagram_username: profileData.instagram_username,
        youTube_username: profileData.youTube_username,
        tikTok_username: profileData.tikTok_username,
        YouTube_Rate: profileData.dedicated_youTube_rate,
        partial_youTube_rate: profileData.partial_youTube_rate,
        youTube_shorts_rate: profileData.youTube_shorts_rate,
        IG_reel_rate: profileData.IG_reel_rate,
        IG_Story_rate: profileData.IG_Story_rate,
        IG_Feed_rate: profileData.IG_Feed_rate,
        tikTok_rate: profileData.tikTok_rate,
        usage_rate: profileData.usage_rate,
        dedicated_youTube_rate: profileData.dedicated_youTube_rate,
        categories: profileData.categories,
        country: profileData.country,
        yt_subscriber_count: profileData.yt_subscriber_count,
        yt_us_percentage: profileData.yt_us_percentage,
        yt_female_percentage: profileData.yt_female_percentage,
        yt_male_percentage: profileData.yt_male_percentage,
        ig_followers_count: profileData.ig_followers_count,
        ig_us_percentage: profileData.ig_us_percentage,
        ig_female_percentage: profileData.ig_female_percentage,
        ig_male_percentage: profileData.ig_male_percentage,
        tk_followers_count: profileData.tk_followers_count,
        tk_us_percentage: profileData.tk_us_percentage,
        tk_female_percentage: profileData.tk_female_percentage,
        tk_male_percentage: profileData.tk_male_percentage,
      });

      // setDate({
      //   rough_draft_date: viewData.rough_draft_date,
      //   live_date: viewData.live_date,
      //   invoice_date: viewData.invoice_date,
      //   payout_date: viewData.payout_date,
      //   date_received: viewData.date_received,
      // })
    }
  }, [profileData]);

  useEffect(() => {
    if (paymentInfo) {
      setPaymentInputValue({
        payees_name: paymentInfo?.payees_name,
        bank_name: paymentInfo?.bank_name,
        account_number: paymentInfo?.account_number,
        routing_number: paymentInfo?.routing_number,
        wires_domestic: paymentInfo?.wires_domestic,
        swift_code: paymentInfo?.swift_code,
        paypal_email: paymentInfo?.paypal_email,
        zelle_email: paymentInfo?.zelle_email,
      });
    }
  }, [paymentInfo]);

  useEffect(() => {
    if (viewData1 && editedInvoice) {
      // Extract current invoice numbers from inputValue

      const originalInvoiceNumbers = viewData1.map(
        (item) => item.invoice_number
      );
      // Find removed invoice numbers
      const removedInvoiceNumbers = originalInvoiceNumbers.filter(
        (number) => !editedInvoice.includes(number)
      );

      // Find removed invoice details
      const removedInvoices = viewData1.filter((item) =>
        removedInvoiceNumbers.includes(item.invoice_number)
      );

      const RemoveInvoicesId = removedInvoices.map((item) => item.id);
      setDeleteInvoiceId(RemoveInvoicesId);
    }
  }, [viewData1, editedInvoice]);

  useEffect(() => {
    const Pathname = window?.location?.pathname;
    const Parts = Pathname.split("/");
    const Extractpath = Parts[Parts.length - 1];
    const Tal_name = Parts[Parts.length - 2];
    setTalName(Tal_name);
    setID(Extractpath);
  });

  useEffect(() => {
    const profileEl = document.querySelector(".inf-profile");

    if (profileEl) {
      profileEl.style.height = "100vh";
    }

    return () => {
      if (profileEl) {
        profileEl.style.height = "";
      }
    };
  }, []);

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentInputValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchCountries = async () => {
    try {
      const response = await fetch(
        "https://restcountries.com/v3.1/all/?fields=name",
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      const countryNames = data.map(
        (country) => country.name.nativeName.eng?.common || country.name.common
      );
      setCountries(countryNames.sort());
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountries([
        "India",
        "United States",
        "United Kingdom",
        "Canada",
        "Germany",
        "France",
        "Australia",
        "Brazil",
        "Japan",
        "Other",
      ]);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const FetchProfileData = async (ID) => {
    setIsLoading(true);
    try {
      const result = await axios.get(`${BASE_URL}/influencer-profile/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setProfilePictureUrl(result?.data?.user_profile_data.profile_picture_url);

      setProfileData(result.data?.influencer_data);
      localStorage.setItem(
        "userImg",
        result?.data?.user_profile_data.profile_picture_url
      );
      dispatch(setUserImg(result?.data?.user_profile_data.profile_picture_url));

      const metaTags = result.data?.influencer_data?.meta_tags;

      const tags =
        typeof metaTags === "string" ? metaTags.split(",") : metaTags;
      setTags(tags);
      setSelectedMetaTags(tags);
      setIsPremium(result.data?.is_premium);
      if (result) {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const getEmailStatus = async () => {
    setIsLoading(true);
    try {
      const result = await fetch(BASE_URL + "/check-email-status/", {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (result.status === 200) {
        const res = await result.json();

        setConnectedMail(res?.email);
        setIsConnected(true);
      } else {
        setIsConnected(false);
      }
      if (result) {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const FetchPlanInfo = async () => {
    setIsLoading(true);
    try {
      const result = await axios.get(`${BASE_URL}/plans/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPlanInfo(result?.data?.data);

      if (result) {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const CheckCurrentPLan = async () => {
    setIsLoading(true);
    try {
      const result = await axios.get(`${BASE_URL}/activeplans/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (result) {
        setIsLoading(false);
        setCurrentMembership(result?.data?.data);
      }
    } catch (error) {
      setIsLoading(false);
      setCurrentMembership(null);
    }
  };

  useEffect(() => {
    FetchPlanInfo();
    getEmailStatus();
    checkFeatureAccess();
    CheckCurrentPLan();
  }, []);

  useEffect(() => {
    if (ID) {
      FetchProfileData(ID);
      FetchPaymentInfo();
    }
  }, [ID]);

  const FetchPaymentInfo = async (ID) => {
    setIsLoading(true);
    try {
      const result = await axios.get(`${BASE_URL}/inf-payment-info/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPaymentInfo(result?.data?.data);

      if (result) {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  // Call FetchProfileData when updateApi changes
  useEffect(() => {
    if (updateApi && ID) {
      FetchProfileData(ID);
    }
  }, [updateApi, ID]);

  useEffect(() => {
    FetchProfileData();
    FetchPaymentInfo();
  }, []);

  useEffect(() => {
    if (updateApi) {
      FetchProfileData();
      FetchPaymentInfo();
    }
  }, [updateApi]);

  useEffect(() => {
    const routesConfig = [
      {
        path: "/admin",
        role: "Admin",
      },
      {
        path: "/creator",
        role: "Creator Manager",
      },
      {
        path: "/influencer",
        role: "Influencer",
      },
    ];

    const userRoute = routesConfig.find((route) => route.role === roles)?.path;
    setMainPath(userRoute);
  }, [roles]);

  const handleExit = () => {
    const allDealsPage = localStorage.getItem("allDealsPage");
    if (allDealsPage) {
      const TabIndex = localStorage.getItem("TabIndex");
      const allDealsPage = localStorage.getItem("allDealsPage");
      const DealsPage = localStorage.getItem("page");
      navigate(
        `${mainPath}/deals?page=${DealsPage}&AllPages=${allDealsPage}&Tabs=${TabIndex}`
      );
    } else if (roles === "Influencer") {
      navigate(`${mainPath}/All_Deals?page=1`);
    } else {
      let talentName = location.state?.talent_name; // Try to get talent_name from location.state
      if (!talentName) {
        const pathnameParts = window.location.pathname.split("/");
        talentName = pathnameParts[pathnameParts.length - 2]; // Assuming talent_name is the second last part of the pathname
      }

      let id = location.state?.influencer_id;
      if (!id) {
        id = InfluencersId;
      }

      navigate(`${mainPath}/${talentName}/cm/${id}`, {
        state: {
          id: id,
          // id: location.state?.influencer_id,
          tal_name: talentName, // Use the extracted or fallback talentName
        },
      });

      // navigate(`/admin/${location.state.talent_name} `, { state: { id: location.state.influencer_id, tal_name: location.state.talent_name } });
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle case where dateString is undefined or null
    const parsedDate = parseISO(dateString);
    return format(parsedDate, "MM/dd/yyyy");
  };

  const handleSave = async () => {
    if (activeTabIndex === 6) {
      if (paymentInfo) {
        try {
          const response = await fetch(BASE_URL + "/inf-payment-info/", {
            method: "PUT",
            body: JSON.stringify(paymentInputValue), // Corrected this line
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

          if (response.status === 401) {
            console.error("Unauthorized: User session expired");
            localStorage.removeItem("userEmail");
            localStorage.removeItem("token");
            window.location.href = "/login";
            return; // exit the function after redirect
          }

          if (!response.ok) {
            console.error("Response Status:", response.status);
            console.error("Response Status Text:", response.statusText);
            throw new Error("Network response was not ok");
          }

          // Check if the response is JSON
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
            const result = await response.json();

            toast({
              title: "Payment Info Updated",
              description: "Payment Info successfully updated.",
              status: "success",
              position: "bottom",
              duration: 3000,
              isClosable: true,
            });
            setSelectedImage("");
            setIsEditing(false);
            setUpdateApi(true);
          } else {
            console.error("Expected JSON response but received:", contentType);
            throw new Error("Received non-JSON response");
          }
        } catch (error) {
          console.error("Save failed:", error);

          toast({
            title: "Error",
            description: error.message || "Error updating Payment Info.",
            status: "error",
            position: "bottom",
            duration: 3000,
            isClosable: true,
          });

          setUpdateApi(false);
        }
      } else {
        try {
          const response = await fetch(BASE_URL + "/inf-payment-info/", {
            method: "POST",
            body: JSON.stringify(paymentInputValue), // Corrected this line
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

          if (response.status === 401) {
            console.error("Unauthorized: User session expired");
            localStorage.removeItem("userEmail");
            localStorage.removeItem("token");
            window.location.href = "/login";
            return; // exit the function after redirect
          }

          if (!response.ok) {
            console.error("Response Status:", response.status);
            console.error("Response Status Text:", response.statusText);
            throw new Error("Network response was not ok");
          }

          // Check if the response is JSON
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
            const result = await response.json();

            toast({
              title: "Payment Info Updated",
              description: "Payment Info successfully updated.",
              status: "success",
              position: "bottom",
              duration: 3000,
              isClosable: true,
            });
            setSelectedImage("");
            setIsEditing(false);
            setUpdateApi(true);
          } else {
            console.error("Expected JSON response but received:", contentType);
            throw new Error("Received non-JSON response");
          }
        } catch (error) {
          console.error("Save failed:", error);

          toast({
            title: "Error",
            description: error.message || "Error updating Payment Info.",
            status: "error",
            position: "bottom",
            duration: 3000,
            isClosable: true,
          });

          setUpdateApi(false);
        }
      }
    } else {
      const updatedData = {
        ...inputValue,
        profile_picture_url: profilePictureUrl,
        meta_tags: selectedMetaTags,
      };

      try {
        const response = await fetch(BASE_URL + "/influencer-profile-update/", {
          method: "PATCH",
          body: JSON.stringify(updatedData), // Corrected this line
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 401) {
          console.error("Unauthorized: User session expired");
          localStorage.removeItem("userEmail");
          localStorage.removeItem("token");
          window.location.href = "/login";
          return; // exit the function after redirect
        }

        if (!response.ok) {
          console.error("Response Status:", response.status);
          console.error("Response Status Text:", response.statusText);
          throw new Error("Network response was not ok");
        }

        // Check if the response is JSON
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          const result = await response.json();

          toast({
            title: "Profile Updated",
            description: "profile successfully updated.",
            status: "success",
            position: "bottom",
            duration: 3000,
            isClosable: true,
          });
          setSelectedImage("");
          setIsEditing(false);
          setUpdateApi(true);
        } else {
          console.error("Expected JSON response but received:", contentType);
          throw new Error("Received non-JSON response");
        }
      } catch (error) {
        console.error("Save failed:", error);

        toast({
          title: "Error",
          description: error.message || "Error updating deals.",
          status: "error",
          position: "bottom",
          duration: 3000,
          isClosable: true,
        });

        setUpdateApi(false);
      }
    }
  };

  const handleEdit = () => {
    setIsEditing(!isEditing);
    setUpdateApi(false);
    setCompnaySearch(false);
  };

  const handleChange = (event) => {
    const name = event.target.name;

    const value = event.target.value;

    if (name === "meta_tags") {
      // Split the input value by commas to create an array
      const tagsArray = value
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);

      setInputValue((prev) => ({ ...prev, [name]: tagsArray }));
    }
    setInputValue((prev) => ({ ...prev, [name]: value }));
    if (name === "invoice") {
      // Process the value for invoice field
      const newItems = value
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean); // Split by comma and clean up

      // Set the edited invoice data
      setEditedInvoice(newItems);
    }
  };

  const handleDateChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setDate((prev) => ({ ...prev, [name]: value || null }));
  };

  const formatNotes = (notes) => {
    return notes?.split("\n")?.map((line, index) => <p key={index}>{line}</p>);
  };

  const formatSplits = (value) => {
    if (value == null || value === "") {
      return "";
    }
    const Values = `${value}%`;
    return Values;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      handleFileUpload(file);
    }
  };

  const generateLink = (text) => {
    return <Link style={{ color: "SteelBlue" }}>{text}</Link>;
  };

  const handleFileUpload = async (file) => {
    const Deal_ids = viewData?.deal_id;

    if (!file) return;
    const formData = new FormData();
    formData.append("contract_file", file);

    try {
      const response = await fetch(`${BASE_URL}/deal-contract/${Deal_ids}/`, {
        method: "PUT",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`, // If you need to pass a token
        },
      });
      const data = await response.json();

      if (data) {
        //    setReview(data.review.response)
        toast({
          title: "File uploaded",
          description: "Your file has been uploaded successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Upload failed",
          description: "There was an error uploading your file.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Upload faileds",
        description: "There was an error uploading your file.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      console.error("Error uploading file:", error);
    } finally {
      setIsLoading(false);
      FetchProfileData();
      //   window.location.reload()
    }
  };

  const handleImageChange = (e) => {
    setSelectedImage(e.target.files[0]);
    imageInputRef.current.value = null;
  };

  const formatAmount = (value) => {
    const Formatvalue = parseFloat(value);
    const newValue = Formatvalue.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return newValue;
  };

  const handleUploadProfilePicture = () => {
    const formData = new FormData();
    formData.append("profile_picture", selectedImage);
    setIsFileLoading(true);

    fetch(BASE_URL + "/update-picture/", {
      method: "PATCH",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 401) {
          localStorage.removeItem("userEmail");
          localStorage.removeItem("token");
          navigate("/login");
          throw new Error("Unauthorized: User session expired");
        }
        return response.json();
      })
      .then((data) => {
        setIsFileLoading(false);
        setProfilePictureUrl(data?.profile_picture);
        setSelectedImage("");

        if (data?.profile_picture) {
          toast({
            title: "Profile picture has been uploaded.",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Failed to upload profile picture.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      })
      .catch((error) => {
        setIsFileLoading(false);

        toast({
          title: "Failed to upload profile picture.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });

        console.error("Error:", error);
      });
  };

  // useEffect(()=>{
  // handleSave()
  // },[profilePictureUrl])

  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const handleRemove = async () => {
    // Optionally clear the profile picture URL locally
    setProfilePictureUrl(null);

    try {
      const response = await fetch(`${BASE_URL}/delete-picture/`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          // Add any required authorization headers, e.g., 'Authorization': `Bearer ${token}`
        },
        // If any body content is needed, add it here. For DELETE, it's often not required.
      });

      if (response.ok) {
        // Successfully deleted the picture

        // Optionally clear the profile picture URL or update the state
        setProfilePictureUrl(null);
      } else {
        // Handle errors
        const errorData = await response.json();
        console.error("Error removing profile picture:", errorData);
        // Optionally show an error message to the user
        toast({
          title: "Error",
          description: "Failed to remove profile picture.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Network error:", error);
      // Handle network or other unexpected errors
      toast({
        title: "Network Error",
        description: "Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  const handleMetaTagClick = (tag) => {
    // Add the selected tag to your state that tracks selected tags.
    if (!selectedMetaTags.includes(tag)) {
      setSelectedMetaTags([...selectedMetaTags, tag]);
    }

    // Remove the selected tag from the list of displayed tags.
    const updatedFilteredMetaTagData = filteredMetaTagData.filter(
      (t) => t !== tag
    );
    setFilteredMetaTagData(updatedFilteredMetaTagData);

    // Don't toggle the dropdown visibility here. This keeps it open.
  };

  const handleMetaTagClose = (metaTag) => {
    const updatedMetaTags = selectedMetaTags.filter((item) => item !== metaTag);
    setSelectedMetaTags(updatedMetaTags);
  };
  const filteredMetaTags = metaTags?.filter((tag) =>
    tag.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const GenerateMetaTag = (value) => {
    const tagsArray = typeof value === "string" ? value.split(",") : value;
    // const tagsArray = Array.isArray(value) ? value : [value];

    return (
      <Wrap
        maxH="50px"
        overflowY="auto"
        pr="2"
        sx={{
          "&::-webkit-scrollbar": { width: "2px" },
          "&::-webkit-scrollbar-track": { background: "#f1f1f1" },
          "&::-webkit-scrollbar-thumb": { background: "#888" },
          "&::-webkit-scrollbar-thumb:hover": { background: "#555" },
        }}
      >
        {tagsArray?.map((tag, index) => (
          <Tag
            key={index}
            variant="solid"
            colorScheme="purple"
            size={"sm"}
            borderRadius="full"
            _hover={{ bg: "#603fad" }}
          >
            <TagLabel>{tag}</TagLabel>
          </Tag>
        ))}
      </Wrap>
    );
  };

  const fetchMetaTags = async () => {
    try {
      const response = await fetch(`${BASE_URL}/get-metatag/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code === "token_not_valid") {
        localStorage.removeItem("userEmail");
        localStorage.removeItem("token");
        navigate("/login");
      }
      const tags = data?.metatag || [];
      const availableTags = tags.filter(
        (tag) => !selectedMetaTags.includes(tag)
      );

      setMetaTags(availableTags);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchMetaTags();
  }, [selectedMetaTags]);

  useEffect(() => {
    if (activeMetaTagDropdown) {
      // fetchMetaTags();
    }
  }, [activeMetaTagDropdown]);

  const connectMail = useGoogleLogin({
    flow: "auth-code",
    scope: scopes.join(" "),
    onSuccess: async (codeResponse) => {
      setIsLoading(true);
      try {
        const response = await fetch(`${BASE_URL}/add_user_emails/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            code: codeResponse.code,
            payloadvalue: 2,
          }),
        });

        const res = await response.json();

        if (response.status === 201) {
          getEmailStatus();
          toast({
            title: "Email Verification",
            description: res.message,
            status: "success",
            position: "top-right",
            duration: 3000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Email Verification",
            description: res.message || "Unknown response",
            status: "info",
            position: "bottom",
            duration: 3000,
            isClosable: true,
          });
        }
      } catch (error) {
        toast({
          title: "Email Verification",
          description: "Something went wrong!",
          status: "error",
          position: "bottom",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setIsLoading(false);
      }
    },
    onError: (errorResponse) => {
      console.error("Google login error:", errorResponse);
    },
  });

  const handleEmailConnect = async () => {
    if (isConnected) {
      setIsLoading(true);
      try {
        const result = await axios.get(`${BASE_URL}/disconnect/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (result) {
          getEmailStatus();
          setIsLoading(false);
          toast({
            title: "Email Disconnect",
            description: result.message,
            status: "success",
            position: "top-right",
            duration: 3000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Email Verification",
            description: result.message || "Unknown response",
            status: "info",
            position: "bottom",
            duration: 3000,
            isClosable: true,
          });
        }
      } catch (error) {
        setIsLoading(false);
        toast({
          title: "Email Disconnect",
          description: "Something went wrong!",
          status: "error",
          position: "bottom",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setIsLoading(false);
      }
    } else {
      connectMail();
    }
  };
  const handleUpgrade = async (targetMembership) => {
    toast({
      title: "Upgrade Initiated",
      description: `Upgrading to ${targetMembership.plan_name} membership. You'll be redirected to PayPal for payment.`,
      status: "info",
      duration: 5000,
      isClosable: true,
    });
    const updatedData = {
      plan_id: targetMembership.plan_id,
      plan_type: targetMembership.plan_name,
    };

    try {
      const response = await fetch(BASE_URL + "/create-subscription/", {
        method: "POST",
        body: JSON.stringify(updatedData), // Corrected this line
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401) {
        console.error("Unauthorized: User session expired");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("token");
        window.location.href = "/login";
        return; // exit the function after redirect
      }

      if (!response.ok) {
        console.error("Response Status:", response.status);
        console.error("Response Status Text:", response.statusText);
        throw new Error("Network response was not ok");
      }

      // Check if the response is JSON
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        const result = await response.json();

        window.open(result.approval_url, "_blank");

        // toast({
        //   title: "Upgrade Complete",
        //   description: `You are now on the ${targetMembership} plan!`,
        //   status: "success",
        //   duration: 5000,
        //   isClosable: true,
        // });
        // setCurrentMembership(targetMembership.plan_name);
        CheckCurrentPLan();
        setIsEditing(false);
        setUpdateApi(true);
      } else {
        console.error("Expected JSON response but received:", contentType);
        throw new Error("Received non-JSON response");
      }
    } catch (error) {
      console.error("Save failed:", error);

      toast({
        title: "Error",
        description: error.message || "Error .",
        status: "error",
        position: "bottom",
        duration: 3000,
        isClosable: true,
      });

      setUpdateApi(false);
    }
  };

  const handleDowngrade = async (targetMembership) => {
    toast({
      title: "Downgrade Initiated",
      description: `Your subscription will be cancelled. You'll still have access to your current features until the end of the billing cycle.`,
      status: "info",
      duration: 5000,
      isClosable: true,
    });
    const updatedData = {
      subscription_id: targetMembership,
    };

    try {
      const response = await fetch(BASE_URL + "/cancel-subscription/", {
        method: "POST",
        body: JSON.stringify(updatedData), // Corrected this line
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        console.error("Response Status:", response.status);
        console.error("Response Status Text:", response.statusText);
        throw new Error("Network response was not ok");
      }
      CheckCurrentPLan();
      setIsEditing(false);
      setUpdateApi(true);
    } catch (error) {
      console.error("Save failed:", error);

      toast({
        title: "Error",
        description: error.message || "Error .",
        status: "error",
        position: "bottom",
        duration: 3000,
        isClosable: true,
      });

      setUpdateApi(false);
    }

    // setTimeout(() => {
    //   setCurrentMembership(targetMembership.plan_name);
    //   toast({
    //     title: "Downgrade Complete",
    //     description: `Your membership has been changed to ${targetMembership}.`,
    //     status: "success",
    //     duration: 5000,
    //     isClosable: true,
    //   });
    //}, 2000);
  };
  // const getButtonProps = (planType) => {
  //   const isFree = !currentMembership || currentMembership.plan_name === "free";

  //   // 1. If this is the current plan
  //   if ((currentMembership?.plan_name || "free") === planType.plan_name && currentMembership.status=="ACTIVE")  {
  //     return {
  //       children: "Current",
  //       bg: "#d3d3d3",
  //       fontSize: "lg",
  //       fontWeight: "bold",
  //       border: "1px solid gray",
  //       color: "#000",
  //       _disabled: {
  //         opacity: 1,
  //         cursor: "not-allowed",
  //       },
  //       isDisabled: true,
  //     };
  //   }

  //   // 2. If the current plan is free, show upgrade button for all other plans
  //   if (isFree) {
  //     return {
  //       children: "Upgrade",
  //       colorScheme: "blue",
  //       fontSize: "lg",
  //       fontWeight: "bold",
  //       border: "1px solid gray",
  //       onClick: () => handleUpgrade(planType),
  //     };
  //   }

  //   // 3. Show downgrade option if the target plan is "free"
  //   if (planType?.plan_name === "free") {
  //     return {
  //       children: "Downgrade",
  //       bg: "#000",
  //       color: "#fff",
  //       fontSize: "lg",
  //       _hover: { bg: "#000" },
  //       border: "1px solid gray",
  //       fontWeight: "bold",
  //       onClick: () => handleDowngrade(currentMembership?.subscription_id),
  //     };
  //   }

  //   // 4. If upgrade is allowed based on suggestion list
  //   if (
  //     Array.isArray(currentMembership?.suggestion_upgrade_plan) &&
  //     currentMembership.suggestion_upgrade_plan.includes(planType.plan_name)
  //   ) {
  //     return {
  //       children: "Upgrade",
  //       colorScheme: "blue",
  //       fontSize: "lg",
  //       fontWeight: "bold",
  //       border: "1px solid gray",
  //       onClick: () => handleUpgrade(planType),
  //     };
  //   }

  //   // 5. Default: disabled upgrade
  //   return {
  //     children: "Upgrade",
  //     bg: "#d3d3d3",
  //     fontSize: "lg",
  //     fontWeight: "bold",
  //     border: "1px solid gray",
  //     isDisabled: true,
  //   };
  // };

  const getButtonProps = (planType) => {
    const noActiveMembership =
      !currentMembership || currentMembership.status !== "ACTIVE";
    console.log("noActiveMembership", noActiveMembership);
    const isFreePlan = planType.plan_name === "free";
    console.log("isFreePlan", isFreePlan);
    const isCurrentFree = noActiveMembership && isFreePlan;
    console.log("isCurrentFree", isCurrentFree);

    if (isPremium) {
      if (currentMembership?.plan_name === "Complete") {
        return {
          children: "Current",
          bg: "#d3d3d3",
          fontSize: "lg",
          fontWeight: "bold",
          border: "1px solid gray",
          color: "#000",
          _disabled: {
            opacity: 1,
            cursor: "not-allowed",
          },
          isDisabled: true,
        };
      }
    } else if (
      currentMembership?.status === "ACTIVE" &&
      currentMembership?.plan_name === planType.plan_name
    ) {
      return {
        children: "Current",
        bg: "#d3d3d3",
        fontSize: "lg",
        fontWeight: "bold",
        border: "1px solid gray",
        color: "#000",
        _disabled: {
          opacity: 1,
          cursor: "not-allowed",
        },
        isDisabled: true,
      };
    } else {
      console.log("testing");
      return {
        children: "Downgrade",
        bg: "#d3d3d3",
        fontSize: "lg",
        fontWeight: "bold",
        border: "1px solid gray",
        isDisabled: true,
      };
    }

    // 2. If no active membership and this is the free plan
    if (isCurrentFree) {
      return {
        children: "Current",
        bg: "#d3d3d3",
        fontSize: "lg",
        fontWeight: "bold",
        border: "1px solid gray",
        color: "#000",
        _disabled: {
          opacity: 1,
          cursor: "not-allowed",
        },
        isDisabled: true,
      };
    }

    // 3. If current plan is treated as free (inactive or missing), and this is not free
    if (noActiveMembership) {
      return {
        children: "Upgrade",
        colorScheme: "blue",
        fontSize: "lg",
        fontWeight: "bold",
        border: "1px solid gray",
        onClick: () => handleUpgrade(planType),
      };
    }

    // 4. Downgrade to free
    if (isFreePlan) {
      return {
        children: "Downgrade",
        bg: "#000",
        color: "#fff",
        fontSize: "lg",
        _hover: { bg: "#000" },
        border: "1px solid gray",
        fontWeight: "bold",
        // onClick: () => handleDowngrade(currentMembership?.subscription_id),
        onClick: () => setIsOpenClockConfirmationModel(true),
      };
    }

    // 5. Upgrade based on suggestions
    if (
      Array.isArray(currentMembership?.suggestion_upgrade_plan) &&
      currentMembership.suggestion_upgrade_plan.includes(planType.plan_name)
    ) {
      return {
        children: "Upgrade",
        colorScheme: "blue",
        fontSize: "lg",
        fontWeight: "bold",
        border: "1px solid gray",
        onClick: () => handleUpgrade(planType),
      };
    }

    // 6. Default: disabled upgrade
    return {
      children: "Upgrade",
      bg: "#d3d3d3",
      fontSize: "lg",
      fontWeight: "bold",
      border: "1px solid gray",
      isDisabled: true,
    };
  };

  if (!isFeatureAccess && showBlockedModal) {
    return (
      <Box>
        <PremiumFeatureModal
          isOpen={true}
          onClose={async () => {
            //  setAccessLoading(true);
            setShowBlockedModal(false);
            navigate(-1);
          }}
          message={featureMessage}
        />
      </Box>
    );
  }

  const handleScan = async () => {
    setIsScanning(true);
    setLabels([]); // Clear previous labels
    setSelectedLabels([]); // Clear previous selections
    setSelectAll(false);

    try {
      const response = await fetch(`${BASE_URL}/get-labels/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setLabels(data.labels || []); // Assuming the API returns a `labels` array
      } else {
        console.error("Failed to fetch labels:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching labels:", error);
    } finally {
      setIsScanning(false);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedLabels([]);
    } else {
      setSelectedLabels(labels);
    }
    setSelectAll(!selectAll);
  };

  const handleLabelSelect = (label) => {
    if (selectedLabels.some((selected) => selected.id === label.id)) {
      setSelectedLabels(selectedLabels.filter((item) => item.id !== label.id));
    } else {
      setSelectedLabels([...selectedLabels, label]);
    }
  };

  return (
    <>
      {/* <ChakraProvider /> */}

      <Box
        px={5}
        py={3}
        className="deal_page_container new_deal_form"
        height={"100vh"}
      >
        <SkeletonText
          noOfLines={20}
          spacing="2"
          skeletonHeight="6"
          isLoaded={!isLoading}
        >
          <Box className="top_action_btn">
            <Button
              className="cancel_btn"
              size={"sm"}
              colorScheme="blue"
              onClick={handleEdit}
            >
              {isEditing ? "Cancel" : "Edit"}
            </Button>

            {isEditing && (
              <Button size={"sm"} colorScheme="blue" onClick={handleSave}>
                Save
              </Button>
            )}
          </Box>

          <Box>
            <Tabs
              index={activeTabIndex}
              onChange={handleTabSelect}
              className="tabs all-tab"
            >
              <TabList>
                <Tab className="tab_head">Personal</Tab>
                <Tab className="tab_head">YouTube</Tab>
                <Tab className="tab_head">Instagram</Tab>
                <Tab className="tab_head">TikTok</Tab>
                <Tab className="tab_head">Usage</Tab>
                <Tab
                  className="tab_head"
                  onClick={() => setActiveMetaTagDropdown(true)}
                >
                  Meta Tags
                </Tab>
                <Tab className="tab_head">Payment Info</Tab>
                <Tab className="tab_head">Connect</Tab>
                <Tab className="tab_head">Import Data</Tab>
                <Tab className="tab_head">Membership</Tab>
              </TabList>

              <TabPanels
                // maxH="365px"
                // overflowY="auto"
                h="auto" // explicitly allow auto height
                minH="unset"
                maxH="unset"
                pr="2"
                w="250px"
                sx={{
                  "&::-webkit-scrollbar": { width: "2px" },
                  "&::-webkit-scrollbar-track": { background: "#f1f1f1" },
                  "&::-webkit-scrollbar-thumb": { background: "#888" },
                  "&::-webkit-scrollbar-thumb:hover": { background: "#555" },
                }}
              >
                <TabPanel
                  className={`  tab_deatil personal_data ${
                    !isEditing ? "edit_tab" : ""
                  }`}
                >
                  <div
                    className="overflow_box new_box_style"
                    style={{
                      height: "60vh",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <div className="overflow_height">
                      <div className="form_list">
                        <span className="detail">Profile Picture</span>
                        {isEditing && !profilePictureUrl ? (
                          <FormControl
                            maxW={"50%"}
                            border={"2px dashed blue"}
                            borderRadius={"10px"}
                            p={"30px 100px"}
                            className="edit-profile"
                          >
                            <FormLabel
                              fontSize="sm"
                              position="absolute"
                              top="-3"
                              left="3"
                              zIndex="1"
                              background="#ffffff"
                              px="1"
                            >
                              Profile Picture
                            </FormLabel>
                            <Flex
                              flexDirection={"column"}
                              alignItems={"center"}
                              color={"#6B6F7A"}
                            >
                              <IoImages size={25} />
                              <Text fontSize={"sm"} mt={"3px"}>
                                <Link
                                  textDecoration={"underline"}
                                  color={"blue"}
                                  onClick={() => imageInputRef.current.click()}
                                >
                                  Click to upload
                                </Link>{" "}
                                an image
                              </Text>
                              {selectedImage && (
                                <>
                                  <Flex
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                  >
                                    <Text>{selectedImage?.name}</Text>
                                    {/* <RxCross2 size={16} color={"red"} cursor={"pointer"} onClick={() => setSelectedImage(null)}  />   */}
                                  </Flex>
                                  <Button
                                    isLoading={isFileLoading}
                                    mt={3}
                                    variant="outline"
                                    colorScheme="green"
                                    size={"sm"}
                                    onClick={handleUploadProfilePicture}
                                  >
                                    Upload
                                  </Button>
                                </>
                              )}
                              <Input
                                type="file"
                                name="profilePicture"
                                style={{ display: "none" }}
                                onChange={handleImageChange}
                                ref={imageInputRef}
                                accept="image/png, image/jpeg, image/webp"
                                alt=""
                              />
                            </Flex>
                          </FormControl>
                        ) : (
                          <>
                            <span>
                              {profilePictureUrl && (
                                <Image
                                  alt="Profile Picture"
                                  src={profilePictureUrl}
                                  borderRadius="full"
                                  boxSize="140px"
                                  objectFit="cover"
                                />
                              )}
                            </span>
                            {profilePictureUrl && isEditing && (
                              <button
                                onClick={handleRemove}
                                className="remove-button-profile"
                              >
                                <p className="buttton-text-remove">Remove</p>
                              </button>
                            )}
                          </>
                        )}
                      </div>
                      <div className="field_list">
                        <div className="form_list">
                          <span className="detail">First Name</span>
                          {isEditing ? (
                            <Box>
                              <Input
                                name="first_name"
                                value={inputValue.first_name}
                                type="text"
                                onChange={handleChange}
                              />
                            </Box>
                          ) : (
                            <span>{profileData.first_name}</span>
                          )}
                        </div>

                        <div className="form_list">
                          <span className="detail">Last Name</span>
                          {isEditing ? (
                            <Menu>
                              <Box>
                                <MenuGroup>
                                  <Input
                                    type="text"
                                    name="last_name"
                                    value={inputValue.last_name}
                                    onChange={handleChange}
                                    // onBlur={handleBlur}
                                    autoFocus
                                  />
                                </MenuGroup>
                              </Box>
                            </Menu>
                          ) : (
                            <span> {profileData.last_name}</span>
                          )}
                        </div>
                      </div>
                      <div className="field_list">
                        <div className="form_list">
                          <span className="detail">Phone Number</span>
                          {isEditing ? (
                            <Menu>
                              <Box>
                                <MenuGroup>
                                  <Input
                                    type="number"
                                    name="phone"
                                    value={inputValue.phone}
                                    onChange={handleChange}
                                    // onBlur={handleBlur}
                                    autoFocus
                                  />
                                </MenuGroup>
                              </Box>
                            </Menu>
                          ) : (
                            <span>{profileData.phone}</span>
                          )}
                        </div>

                        <div className="form_list">
                          <span className="detail">Birthday</span>
                          {isEditing ? (
                            <Menu>
                              <Box>
                                <MenuGroup>
                                  <Input
                                    type="date"
                                    name="birthday"
                                    value={inputValue.birthday}
                                    onChange={handleChange}
                                    // onBlur={handleBlur}
                                    autoFocus
                                  />
                                </MenuGroup>
                              </Box>
                            </Menu>
                          ) : (
                            <span>{formatDate(profileData.birthday)}</span>
                          )}
                        </div>
                      </div>
                      <div className="field_list">
                        {/* Shipping Address Field */}
                        <div className="form_list">
                          <span className="detail">Shipping Address</span>
                          {isEditing ? (
                            <Menu>
                              <Box>
                                <MenuGroup>
                                  <Textarea
                                    type="text"
                                    name="address"
                                    value={inputValue.address}
                                    onChange={handleChange}
                                    autoFocus
                                  />
                                </MenuGroup>
                              </Box>
                            </Menu>
                          ) : (
                            <span>{profileData.address}</span>
                          )}
                        </div>
                        {/* Country Field (Placed Next to Shipping Address) */}
                        <div className="form_list">
                          <span className="detail">Country</span>
                          {isEditing ? (
                            <select
                              name="country"
                              value={inputValue.country}
                              onChange={handleChange}
                              style={{
                                padding: "8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                width: "100%",
                              }}
                            >
                              <option value="">Select Country</option>
                              {countries.map((country, idx) => (
                                <option key={idx} value={country}>
                                  {country}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <span>{profileData.country}</span>
                          )}
                        </div>
                      </div>
                      <div className="form_list">
                        <span className="detail">Categories</span>

                        {isEditing ? (
                          <select
                            multiple
                            name="categories"
                            value={inputValue.categories}
                            onChange={(e) => {
                              const selected = Array.from(
                                e.target.selectedOptions,
                                (option) => option.value
                              );
                              setInputValue({
                                ...inputValue,
                                categories: selected,
                              });
                            }}
                            style={{
                              padding: "10px",
                              border: "1px solid black",
                              borderRadius: "8px",
                              height: "140px",
                              width: "100%",
                              fontSize: "14px",
                              color: "black",
                              outline: "none",
                              transition:
                                "border 0.3s ease, box-shadow 0.3s ease",
                              overflowY: "auto",
                            }}
                          >
                            {[
                              "Art",
                              "ASMR",
                              "Automotive",
                              "Beauty",
                              "Choreography",
                              "Comedy",
                              "Community",
                              "Dance",
                              "DIY",
                              "Entertainment",
                              "Family",
                              "Fashion",
                              "Film & Television",
                              "Fitness",
                              "Food & Cooking",
                              "Gaming",
                              "Health & Wellness",
                              "Home",
                              "Humor & Comedy",
                              "Law",
                              "Lifestyle",
                              "Mental Health",
                              "Modeling",
                              "Motivational",
                              "Music",
                              "Other",
                              "Personal Development",
                              "Pets & Animals",
                              "Plants",
                              "Podcast",
                              "Real Estate",
                              "Relationships",
                              "Social Media",
                              "Sports",
                              "Travel",
                              "YouTuber",
                            ].map((cat, idx) => (
                              <option key={idx} value={cat}>
                                {cat}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <span>
                            {profileData.categories &&
                            profileData.categories.length > 0
                              ? profileData.categories.join(", ")
                              : "N/A"}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </TabPanel>

                {/* <======================================youTube=========================================================> */}

                <TabPanel
                  className={`tab_deatil ${!isEditing ? "edit_tab" : ""}`}
                >
                  <div className="field_list new_box_style">
                    {/* YouTube Username */}
                    <div className="form_list">
                      <span className="detail">YouTube Username</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="text"
                                name="youTube_username"
                                value={inputValue.youTube_username}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <Link
                          style={{ color: "SteelBlue" }}
                          href={`https://www.youtube.com/${profileData?.youTube_username}`}
                          isExternal
                        >
                          {profileData.youTube_username}
                        </Link>
                      )}
                    </div>

                    {/* Dedicated YouTube Rate */}
                    <div className="form_list">
                      <span className="detail">Dedicated YouTube Rate</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="dedicated_youTube_rate"
                                value={inputValue.dedicated_youTube_rate}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {formatAmount(profileData?.dedicated_youTube_rate)}
                        </span>
                      )}
                    </div>

                    {/* Partial YouTube Rate */}
                    <div className="form_list">
                      <span className="detail">Partial YouTube Rate</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="partial_youTube_rate"
                                value={inputValue.partial_youTube_rate}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {formatAmount(profileData?.partial_youTube_rate)}
                        </span>
                      )}
                    </div>

                    {/* YouTube Shorts Rate */}
                    <div className="form_list">
                      <span className="detail">YouTube Shorts Rate</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="youTube_shorts_rate"
                                value={inputValue.youTube_shorts_rate}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {formatAmount(profileData?.youTube_shorts_rate)}
                        </span>
                      )}
                    </div>

                    {/* Subscriber Count */}
                    <div className="form_list">
                      <span className="detail">Subscriber Count</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="yt_subscriber_count"
                                value={inputValue.yt_subscriber_count}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>{profileData.yt_subscriber_count ?? 0}</span>
                      )}
                    </div>

                    {/* US % */}
                    <div className="form_list">
                      <span className="detail">US %</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="yt_us_percentage"
                                value={inputValue.yt_us_percentage}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>{(profileData.yt_us_percentage ?? 0) + "%"}</span>
                      )}
                    </div>

                    {/* Female % */}
                    <div className="form_list">
                      <span className="detail">Female %</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="yt_female_percentage"
                                value={inputValue.yt_female_percentage}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {(profileData.yt_female_percentage ?? 0) + "%"}
                        </span>
                      )}
                    </div>

                    {/* Male % */}
                    <div className="form_list">
                      <span className="detail">Male %</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="yt_male_percentage"
                                value={inputValue.yt_male_percentage}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {(profileData.yt_male_percentage ?? 0) + "%"}
                        </span>
                      )}
                    </div>
                  </div>
                </TabPanel>

                {/* <===================================================Ig============================================> */}
                <TabPanel
                  className={`tab_deatil ${!isEditing ? "edit_tab" : ""}`}
                >
                  <div className="field_list new_box_style">
                    <div className="form_list">
                      <span className="detail">Instagram UserName</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="text"
                                name="instagram_username"
                                value={inputValue.instagram_username}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <Link
                          style={{ color: "SteelBlue" }}
                          href={`https://www.instagram.com/${
                            profileData.instagram_username ?? ""
                          }`}
                          isExternal
                        >
                          {profileData.instagram_username ?? "N/A"}
                        </Link>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">IG Reel Rate</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="IG_reel_rate"
                                value={inputValue.IG_reel_rate}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {formatAmount(profileData.IG_reel_rate ?? 0)}
                        </span>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">IG Story Rate</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="IG_Story_rate"
                                value={inputValue.IG_Story_rate}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {formatAmount(profileData.IG_Story_rate ?? 0)}
                        </span>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">IG Feed Rate</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="IG_Feed_rate"
                                value={inputValue.IG_Feed_rate}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {formatAmount(profileData.IG_Feed_rate ?? 0)}
                        </span>
                      )}
                    </div>

                    <div className="form_list">
                      <span
                        className="detail"
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          display: "block",
                        }}
                      >
                        Follower Count
                      </span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="ig_followers_count"
                                value={inputValue.ig_followers_count}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>{profileData.ig_followers_count ?? 0}</span>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">US %</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="ig_us_percentage"
                                value={inputValue.ig_us_percentage}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>{(profileData.ig_us_percentage ?? 0) + "%"}</span>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">Female %</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="ig_female_percentage"
                                value={inputValue.ig_female_percentage}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {(profileData.ig_female_percentage ?? 0) + "%"}
                        </span>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">Male %</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="ig_male_percentage"
                                value={inputValue.ig_male_percentage}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {(profileData.ig_male_percentage ?? 0) + "%"}
                        </span>
                      )}
                    </div>
                  </div>
                </TabPanel>

                {/* <===========================================tiktok====================================================> */}
                <TabPanel
                  className={`tab_deatil ${!isEditing ? "edit_tab" : ""}`}
                >
                  <div className="field_list new_box_style">
                    <div className="form_list">
                      <span className="detail">TikTok UserName</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="text"
                                name="tikTok_username"
                                value={inputValue.tikTok_username}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <Link
                          style={{ color: "SteelBlue" }}
                          href={`https://www.tiktok.com/${profileData.tikTok_username}`}
                          isExternal
                        >
                          {profileData.tikTok_username}
                        </Link>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">TikTok Rate</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="tikTok_rate"
                                value={inputValue.tikTok_rate}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {formatAmount(profileData.tikTok_rate ?? 0)}
                        </span>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">Follower Count</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="tk_followers_count"
                                value={inputValue.tk_followers_count}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>{profileData.tk_followers_count ?? 0}</span>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">US %</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="tk_us_percentage"
                                value={inputValue.tk_us_percentage}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>{(profileData.tk_us_percentage ?? 0) + "%"}</span>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">Female %</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="tk_female_percentage"
                                value={inputValue.tk_female_percentage}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {(profileData.tk_female_percentage ?? 0) + "%"}
                        </span>
                      )}
                    </div>

                    <div className="form_list">
                      <span className="detail">Male %</span>
                      {isEditing ? (
                        <Menu>
                          <Box>
                            <MenuGroup>
                              <Input
                                type="number"
                                name="tk_male_percentage"
                                value={inputValue.tk_male_percentage}
                                onChange={handleChange}
                                autoFocus
                              />
                            </MenuGroup>
                          </Box>
                        </Menu>
                      ) : (
                        <span>
                          {(profileData.tk_male_percentage ?? 0) + "%"}
                        </span>
                      )}
                    </div>
                  </div>
                </TabPanel>
                {/* ++++++++++++++++++++++++++++++++++++++++++++++Usage++++++++++++++++++++++++++++++++++++++++++++++++ */}
                <TabPanel
                  className={`tab_deatil ${!isEditing ? "edit_tab" : ""}`}
                >
                  <div className="form_list new_box_style">
                    <span className="detail">Usage Rate</span>
                    {isEditing ? (
                      <Menu>
                        <Box>
                          <MenuGroup>
                            <Input
                              type="number"
                              name="usage_rate"
                              value={inputValue.usage_rate}
                              onChange={handleChange}
                              // onBlur={handleBlur}
                              autoFocus
                            />
                          </MenuGroup>
                        </Box>
                      </Menu>
                    ) : (
                      <span> {formatAmount(profileData.usage_rate)}</span>
                    )}
                  </div>
                </TabPanel>
                {/* ++++++++++++++++++++++++++++++++++++++++++++++Meta Tag++++++++++++++++++++++++++++++++++++++++++++++++ */}

                <TabPanel
                  className={`tab_deatil ${!isEditing ? "edit_tab" : ""}`}
                >
                  <div className="form_list form_list2 new_box_style">
                    <span className="detail meta_heading">Meta Tag</span>
                    {isEditing ? (
                      <Menu>
                        <FormLabel
                          fontSize="sm"
                          position="absolute"
                          top="-3"
                          left="3"
                          zIndex="1"
                          background="#ffffff"
                          px="1"
                        >
                          {/* Meta Tags */}
                        </FormLabel>

                        {/* Uncomment this section if you want to use a Select dropdown instead of InputGroup */}
                        {/* <Select name='metaTag' placeholder=' ' value={InfluencerData.metaTag} onChange={handleInfluencerDataChange}>
          {metaTags?.map((tag, index) => (
            <option key={index}>{tag}</option>
          ))}
        </Select> */}

                        {/* <InputGroup cursor={"pointer"} onClick={() => setActiveMetaTagDropdown(!activeMetaTagDropdown)}>
          <Input mb={2} type='text' sx={{ pointerEvents: "none" }} readOnly />
          <InputRightElement>
            <BiCaretDown w={3} h={3} color='gray.400' />
          </InputRightElement>
        </InputGroup> */}

                        {/* {activeMetaTagDropdown && ( */}
                        <Card>
                          <InputGroup>
                            <Input
                              type="text"
                              placeholder="Search Meta Tags"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </InputGroup>
                          {filteredMetaTags?.length > 0 && (
                            <Box
                              my={1}
                              maxH={"145px"}
                              overflowY={"auto"}
                              sx={
                                {
                                  /* ... your custom styles */
                                }
                              }
                            >
                              {filteredMetaTags?.map((tag, index) => (
                                <Text
                                  px={3}
                                  py={1}
                                  fontSize={"sm"}
                                  _hover={{ bg: "#EDF2F7", cursor: "pointer" }}
                                  key={index}
                                  onClick={() => handleMetaTagClick(tag)}
                                >
                                  {tag}
                                </Text>
                              ))}
                            </Box>
                          )}
                        </Card>
                        {/* // )} */}
                        {/* <br></br> */}
                        <div>
                          {selectedMetaTags?.map((metaTag, index) => (
                            <Tag
                              className="custom_meta"
                              key={index}
                              mr={2}
                              mb={2}
                              fontWeight={"400"}
                              size={"md"}
                              borderRadius="full"
                              variant="subtle"
                              colorScheme="purple"
                            >
                              <TagLabel className="custom_meta_text">
                                {metaTag}
                              </TagLabel>
                              <TagCloseButton
                                onClick={() => handleMetaTagClose(metaTag)}
                              />
                            </Tag>
                          ))}
                        </div>
                      </Menu>
                    ) : (
                      <>
                        {tags?.map((metaTag, index) => (
                          <Tag
                            className="custom_meta"
                            key={index}
                            mr={2}
                            mb={2}
                            fontWeight={"400"}
                            size={"md"}
                            borderRadius="full"
                            variant="subtle"
                            colorScheme="purple"
                          >
                            <TagLabel className="custom_meta_text">
                              {metaTag}
                            </TagLabel>
                            {/* <TagCloseButton onClick={() => handleMetaTagClose(metaTag)} /> */}
                          </Tag>
                        ))}
                      </>
                    )}
                  </div>
                </TabPanel>

                {/* ++++++++++++++++++++++++++++++++++++++++++++++payment INFO++++++++++++++++++++++++++++++++++++++++++++++++ */}
                <TabPanel
                  className={`tab_deatil ${!isEditing ? "edit_tab" : ""}`}
                >
                  <div className="mobile-scroll-container new_box_style">
                    <Text
                      m={6}
                      color="gray.700"
                      textAlign="left"
                      marginLeft="0px"
                    >
                      The information you add here will be used when generating
                      an invoice for a deal you've completed.
                    </Text>

                    <div className="payment_field_list">
                      <div
                        className={`payment_form_list ${
                          !isEditing ? "view-mode" : ""
                        }`}
                      >
                        <span className="details">Payee's Name</span>
                        {isEditing ? (
                          <Menu>
                            <Box>
                              <MenuGroup>
                                <Input
                                  type="text"
                                  name="payees_name"
                                  value={paymentInputValue.payees_name}
                                  onChange={handlePaymentChange}
                                  // onBlur={handleBlur}
                                  autoFocus
                                />
                              </MenuGroup>
                            </Box>
                          </Menu>
                        ) : (
                          <span>{paymentInfo?.payees_name}</span>
                        )}
                      </div>

                      <div
                        className={`payment_form_list ${
                          !isEditing ? "view-mode" : ""
                        }`}
                      >
                        <span className="details">Bank Name</span>
                        {isEditing ? (
                          <Menu>
                            <Box>
                              <MenuGroup>
                                <Input
                                  type="text"
                                  name="bank_name"
                                  value={paymentInputValue.bank_name}
                                  onChange={handlePaymentChange}
                                  // onBlur={handleBlur}
                                  autoFocus
                                />
                              </MenuGroup>
                            </Box>
                          </Menu>
                        ) : (
                          <span>{paymentInfo?.bank_name}</span>
                        )}
                      </div>
                    </div>
                    <div className="payment_field_list">
                      <div
                        className={`payment_form_list ${
                          !isEditing ? "view-mode" : ""
                        }`}
                      >
                        <span className="details">Account Number</span>
                        {isEditing ? (
                          <Menu>
                            <Box>
                              <MenuGroup>
                                <Input
                                  type="text"
                                  name="account_number"
                                  value={paymentInputValue.account_number}
                                  onChange={handlePaymentChange}
                                  // onBlur={handleBlur}
                                  autoFocus
                                />
                              </MenuGroup>
                            </Box>
                          </Menu>
                        ) : (
                          <span>{paymentInfo?.account_number}</span>
                        )}
                      </div>

                      <div
                        className={`payment_form_list ${
                          !isEditing ? "view-mode" : ""
                        }`}
                      >
                        <span className="details">Routing Number</span>
                        {isEditing ? (
                          <Menu>
                            <Box>
                              <MenuGroup>
                                <Input
                                  type="text"
                                  name="routing_number"
                                  value={paymentInputValue.routing_number}
                                  onChange={handlePaymentChange}
                                  // onBlur={handleBlur}
                                  autoFocus
                                />
                              </MenuGroup>
                            </Box>
                          </Menu>
                        ) : (
                          <span>{paymentInfo?.routing_number}</span>
                        )}
                      </div>
                    </div>
                    <div className="payment_field_list">
                      <div
                        className={`payment_form_list ${
                          !isEditing ? "view-mode" : ""
                        }`}
                      >
                        <span className="details">Wires (Domestic)</span>
                        {isEditing ? (
                          <Menu>
                            <Box>
                              <MenuGroup>
                                <Input
                                  type="text"
                                  name="wires_domestic"
                                  value={paymentInputValue?.wires_domestic}
                                  onChange={handlePaymentChange}
                                  // onBlur={handleBlur}
                                  autoFocus
                                />
                              </MenuGroup>
                            </Box>
                          </Menu>
                        ) : (
                          <span>{paymentInfo?.wires_domestic}</span>
                        )}
                      </div>

                      <div
                        className={`payment_form_list ${
                          !isEditing ? "view-mode" : ""
                        }`}
                      >
                        <span className="details">
                          SWIFT (International/USD)
                        </span>
                        {isEditing ? (
                          <Menu>
                            <Box>
                              <MenuGroup>
                                <Input
                                  type="text"
                                  name="swift_code"
                                  value={paymentInputValue.swift_code}
                                  onChange={handlePaymentChange}
                                  // onBlur={handleBlur}
                                  autoFocus
                                />
                              </MenuGroup>
                            </Box>
                          </Menu>
                        ) : (
                          <span>{paymentInfo?.swift_code}</span>
                        )}
                      </div>
                    </div>

                    <div className="payment_field_list">
                      <div
                        className={`payment_form_list ${
                          !isEditing ? "view-mode" : ""
                        }`}
                      >
                        <span className="details">PayPal Email Address</span>
                        {isEditing ? (
                          <Menu>
                            <Box>
                              <MenuGroup>
                                <Input
                                  type="email"
                                  name="paypal_email"
                                  value={paymentInputValue.paypal_email}
                                  onChange={handlePaymentChange}
                                  // onBlur={handleBlur}
                                  autoFocus
                                />
                              </MenuGroup>
                            </Box>
                          </Menu>
                        ) : (
                          <span>{paymentInfo?.paypal_email}</span>
                        )}
                      </div>

                      <div
                        className={`payment_form_list ${
                          !isEditing ? "view-mode" : ""
                        }`}
                      >
                        <span className="details">Zelle Email Address</span>
                        {isEditing ? (
                          <Menu>
                            <Box>
                              <MenuGroup>
                                <Input
                                  type="email"
                                  name="zelle_email"
                                  value={paymentInputValue.zelle_email}
                                  onChange={handlePaymentChange}
                                  // onBlur={handleBlur}
                                  autoFocus
                                />
                              </MenuGroup>
                            </Box>
                          </Menu>
                        ) : (
                          <span>{paymentInfo?.zelle_email}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </TabPanel>

                {/* ++++++++++++++++++++++++++++++++++++++++++++++Connect++++++++++++++++++++++++++++++++++++++++++++++++ */}
                <TabPanel
                  className={`tab_deatil ${!isEditing ? "edit_tab" : ""}`}
                >
                  <div className="new_box_style">
                    <Text
                      m={6}
                      color="gray.700"
                      textAlign="left"
                      marginLeft="0px"
                    >
                      Connect your email address that you would like to use to
                      send invoices and outreach emails.
                    </Text>

                    <Box mt={4}>
                      <Button
                        colorScheme={isConnected ? "red" : "blue"}
                        size="md"
                        onClick={handleEmailConnect}
                      >
                        {isConnected ? "Disconnect Email" : "Connect Email"}
                      </Button>

                      {isConnected && (
                        <Box mt={3}>
                          <p>
                            Your account is currently connected to{" "}
                            <strong>{connectedMail}</strong>
                          </p>
                        </Box>
                      )}
                    </Box>
                  </div>
                </TabPanel>
                {/* ++++++++++++++++++++++++++++++++++++++++++++++Import Data++++++++++++++++++++++++++++++++++++++++++++++++ */}

                <TabPanel>
                  {isConnected !== null && (
                    <>
                      {isConnected ? (
                        <Box
                          className="new_box_style"
                          p={4}
                          backgroundColor="white"
                        >
                          {isScanning ? (
                            <Box textAlign="center">
                              <Text fontSize="md" mb={4}>
                                Scanning your email account to locate folders...
                              </Text>
                              <Spinner size="lg" />
                            </Box>
                          ) : labels.length === 0 ? (
                            <>
                              <Text fontSize="md">
                                <strong>
                                  The{" "}
                                  <span style={{ color: "#000" }}>CM hub</span>
                                </strong>{" "}
                                allows you to easily scan your email account to
                                import brands, brand reps, and deals. Note that
                                we do not store your emails, but only store the
                                relevant information needed to build out your{" "}
                                <strong>CM hub</strong> account. Click “scan” to
                                get started.
                              </Text>

                              <Box mt={4}>
                                <button
                                  style={{
                                    backgroundColor: "#337ab7",
                                    color: "white",
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                  onClick={handleScan}
                                >
                                  Scan
                                </button>
                              </Box>
                            </>
                          ) : (
                            <Box>
                              { (!isInProgress && !isLoadingTotal && totalEmails === null) &&
                                <>
                                  <Text fontSize="md" mb={4}>
                                    Select the labels you want the system to scan
                                    during the import process:
                                  </Text>
                                  <Checkbox
                                    isChecked={selectAll}
                                    onChange={handleSelectAll}
                                    mb={2}
                                  >
                                    Select All
                                  </Checkbox>
                                  <VStack
                                    align="start"
                                    spacing={2}
                                    maxH="200px"
                                    overflowY="auto"
                                  >
                                    {labels.map((label, index) => (
                                      <Checkbox
                                        key={index}
                                        isChecked={selectedLabels.some(
                                          (selected) => selected.id === label.id
                                        )}
                                        onChange={() => handleLabelSelect(label)}
                                      >
                                        {label.name}
                                      </Checkbox>
                                    ))}
                                  </VStack>
                                  <Button
                                    colorScheme="blue"
                                    mt={4}
                                    isDisabled={
                                      selectedLabels.length === 0 || isLoadingTotal
                                    }
                                    onClick={async () => {
                                      setIsLoadingTotal(true);
                                      setTotalEmails(null); // Reset previous count
                                      setTimeout(() => {
                                        setMessageInprogress(prev => !prev);
                                      }, 2000)
                                      const startTime = Date.now();

                                      try {
                                        const payload = {
                                          label_ids: selectedLabels.map(
                                            (label) => label.id
                                          ),
                                        };
                                        const response = await axios.post(
                                          BASE_URL + "/total-emails/",
                                          payload,
                                          {
                                            headers: {
                                              Authorization: `Bearer ${token}`,
                                            },
                                          }
                                        );
                                        
                                        const elapsedTime = Date.now() - startTime;
                                        const minWait = 3000;
                                        if (elapsedTime < minWait) {
                                          await new Promise((resolve) => setTimeout(resolve, minWait - elapsedTime));
                                        }
                                        setTotalEmails(response.data.total_emails);
                                      } catch (error) {
                                        console.error(
                                          "Failed to fetch total emails:",
                                          error
                                        );
                                      } finally {
                                        setIsLoadingTotal(false);
                                      }
                                    }}
                                  >
                                    {isLoadingTotal ? "Scanning..." : "Start"}
                                  </Button>
                                </>
                              }
                              {(isLoadingTotal) && (
                                <Text mt={4} fontSize="md">
                                  {
                                    !messageInprogress ? `This process can take some time. You can navigate away from this page or close your browser without disruptingg the process.` : 'Scanning your folders to determine the number of email threads...'
                                  }
                                </Text>
                              )}

                              {totalEmails !== null && !isLoadingTotal && (
                                <Text mt={4} fontSize="md">
                                  We have found <strong>{totalEmails}</strong>{" "}
                                  email threads that will be scanned...
                                </Text>
                              )}
                            </Box>
                          )}
                        </Box>
                      ) : (
                        <Box
                          className="new_box_style"
                          p={4}
                          backgroundColor="white"
                        >
                          <Text fontSize="md" color="red.500">
                            Please connect your email account to begin building
                            out your CM hub account.
                          </Text>
                          <Box mt={4}>
                            <Button
                              colorScheme="blue"
                              onClick={handleEmailConnect}
                            >
                              Connect Email
                            </Button>
                          </Box>
                        </Box>
                      )}
                    </>
                  )}
                </TabPanel>

                {/* ++++++++++++++++++++++++++++++++++++++++++++++Membership++++++++++++++++++++++++++++++++++++++++++++++++ */}
                <TabPanel className="tab_deatil">
                  <Flex justify="center" my={6}>
                    <BillingCycleToggle
                      billingCycle={billingCycle}
                      setBillingCycle={setBillingCycle}
                    />
                  </Flex>

                  {currentMembership?.next_billing_time &&
                    !isPremium &&
                    (currentMembership?.status === "ACTIVE" ? (
                      <Text
                        m={6}
                        color="gray.700"
                        textAlign="left"
                        marginLeft="0px"
                      >
                        Your membership will renew on{" "}
                        <strong>
                          {new Date(
                            currentMembership.next_billing_time
                          ).toLocaleDateString(undefined, {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })}
                        </strong>
                        .
                      </Text>
                    ) : (
                      <Text
                        m={6}
                        color="gray.700"
                        textAlign="left"
                        marginLeft="0px"
                      >
                        Your access to premium features will end on{" "}
                        <strong>
                          {new Date(
                            currentMembership.next_billing_time
                          ).toLocaleDateString(undefined, {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })}
                        </strong>
                        .
                      </Text>
                    ))}

                  <Box
                    overflowX="auto"
                    overflowY="auto"
                    maxW="100%"
                    maxH={{ base: "50vh", md: "100vh" }}
                    px={2}
                  >
                    <Flex
                      direction={{ base: "column", md: "row" }}
                      flexWrap={{ base: "nowrap", md: "nowrap" }}
                      gap={4}
                      justify={{ base: "center", md: "center" }}
                      align={{ base: "center", md: "stretch" }}
                      mt={4}
                      w="100%"
                    >
                      <Box
                        w={{ base: "100%", md: "280px" }}
                        pl={{ base: "25px", md: "0" }}
                      >
                        <PricingCard
                          title="Free"
                          price={0}
                          features={membershipFeatures.free}
                          buttonProps={getButtonProps({ plan_name: "free" })}
                          bgColor="#d3d3d3"
                        />
                      </Box>

                      {planInfo.length > 0 &&
                        planInfo
                          .filter((plan) => plan.billing_cycle === billingCycle)
                          .sort((a, b) => {
                            if (billingCycle === "Annually") {
                              const order = [
                                "Marketing",
                                "Administrative",
                                "Complete",
                              ];
                              return (
                                order.indexOf(a.plan_name) -
                                order.indexOf(b.plan_name)
                              );
                            }
                            return 0; // keep default for Monthly
                          })
                          .map((plan) => {
                            const planName = plan.plan_name;
                            const features = Array.isArray(
                              membershipFeatures[planName]
                            )
                              ? membershipFeatures[planName]
                              : [];

                            // Optional: Set price from plan description or based on plan type
                            const price =
                              billingCycle === "Annually"
                                ? plan.plan_name === "Complete"
                                  ? 15
                                  : 10
                                : plan.plan_name === "Complete"
                                ? 20
                                : 15;

                            const savingsText =
                              billingCycle === "Annually" ? (
                                <Text
                                  fontSize="sm"
                                  color="red.500"
                                  fontWeight="medium"
                                  mt={1}
                                >
                                  Save $60/year
                                </Text>
                              ) : null;

                            return (
                              <Box
                                w={{ base: "100%", md: "280px" }}
                                pl={{ base: "25px", md: "0" }}
                              >
                                <PricingCard
                                  title={plan.plan_name}
                                  extraContent={savingsText}
                                  billingCycle={billingCycle}
                                  price={price}
                                  features={features}
                                  buttonProps={getButtonProps(plan)}
                                  bgColor="#d3d3d3"
                                />
                              </Box>
                            );
                          })}
                    </Flex>
                  </Box>
                </TabPanel>
                <MembershipDowngradeModel
                  isOpen={isOpenClockConfirmationModel}
                  onClose={() => setIsOpenClockConfirmationModel(false)}
                  downgradeMembership={handleDowngrade}
                />

                {/* <===============================================================================================> */}
                <TabPanel
                  className={`tab_deatil ${!isEditing ? "edit_tab" : ""}`}
                >
                  <div className="form_list">
                    {isEditing ? (
                      <Menu>
                        <Box>
                          <MenuGroup>
                            <Textarea
                              type="text"
                              name="notes"
                              value={inputValue.notes}
                              onChange={handleChange}
                              // onBlur={handleBlur}
                              autoFocus
                            />
                          </MenuGroup>
                        </Box>
                      </Menu>
                    ) : (
                      <span>{formatNotes(viewData.notes)}</span>
                    )}
                  </div>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </SkeletonText>
      </Box>
    </>
  );
};

export default ProfileTable;

function PricingCard({
  title,
  extraContent,
  billingCycle,
  price,
  features,
  buttonProps,
  bgColor = "#d3d3d3",
  headerColor = "black",
}) {
  return (
    <Flex
      direction="column"
      maxW="300px"
      w="100%"
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      height="500px"
    >
      <Box bg={bgColor} p={4} textAlign="center">
        <Heading size="lg" color={headerColor}>
          {title}
        </Heading>
      </Box>
      <Text></Text>

      <Flex direction="column" p={6} flex="1">
        <Flex justify="center" align="baseline" mb={6}>
          <Heading size="3xl" fontWeight="bold" color="blue.600">
            ${price}
          </Heading>
          {price > 0 && (
            <Text fontSize="md" fontWeight="bold" color="black" ml={1}>
              /Month
            </Text>
          )}
        </Flex>
        {extraContent && (
          <Text
            fontSize="sm"
            color="red.500"
            fontWeight="medium"
            textAlign="center"
            mb={4}
          >
            {extraContent}
          </Text>
        )}

        <Stack spacing={3} mb={6} flex="1">
          {Array.isArray(features) &&
            features?.map((feature, index) => (
              <Flex key={index} align="center">
                <Checkbox isChecked colorScheme="blue" isReadOnly mr={2} />
                <Text>{feature}</Text>
              </Flex>
            ))}
        </Stack>

        <Box mt="auto">
          <Button w="full" {...buttonProps} />
        </Box>
      </Flex>
    </Flex>
  );
}
